import React, { useState } from "react";

const ExpandableTextMobile = ({ text, className = "long-text" }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!text) return null;

  return (
    <>
      <span onClick={() => setIsExpanded(!isExpanded)} className={`${className} ${isExpanded ? "expanded" : ""}`} title={text}>
        {text}
      </span>
    
    </>
  );
};

export default ExpandableTextMobile;